/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import {
  ORDERS_URL,
} from "constants/url.constant";

import { API } from "api";
import { setError } from "../Indicator";

export const RESET = "RESET";
export const SET_INBOUND_PIECES_LIST = "SET_INBOUND_PIECES_LIST";
export const REQUEST_SHIPMENT_ORDER_INBOUND_PIECES = "REQUEST_SHIPMENT_ORDER_INBOUND_PIECES";

export const resetToInitialState = () => ({
  type: RESET
});

export const setPiecesList = (data) => {
  return {
    type: SET_INBOUND_PIECES_LIST,
    payload: data
  };
};

export const getOrderInboundPieces = (orderId, { page, limit }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPMENT_ORDER_INBOUND_PIECES });
    try {
      const res = await API.get(`${ORDERS_URL}/${orderId}/inbound-pieces?page=${page}&limit=${limit}`);
      dispatch(setPiecesList(res));
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  rows: [],
  totalRows: 0,
  order: null
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case RESET:
      return initialState;
    case SET_INBOUND_PIECES_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    case REQUEST_SHIPMENT_ORDER_INBOUND_PIECES:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    default:
      return state;
  }
}
